import { Stack, Image, FontIcon, Label, IStackTokens, ImageFit } from '@fluentui/react';
import React, { useContext } from 'react';
import styles from '../styles/main.module.scss';
import { NavLink } from 'react-router-dom';
import GlobalContext from '../_contexts/GlobalContext';

export interface IFooterComponentProps {
    UpdateStateExtern?: Function;
}

const Footer : React.FunctionComponent<IFooterComponentProps> = (props : IFooterComponentProps) => {
    const { OUT_EMAIL, WHATSAPP, FOOTER_TEXT, FOOTERHEADERBGCOLOR, FOOTER_TEXT_COLOR } = useContext(GlobalContext);

    const footerTokens: IStackTokens = { childrenGap: '10' };
    
    return (   
        
            <div className={`${styles.divTable}`} style={{width:"100%",borderTop:"1px solid #292885"}}>
                <div className={styles.divTableRow}>
                    <div className={`${styles.divTableCell}`}>
                        <Stack horizontal horizontalAlign='center' tokens={footerTokens}>
                            <div style={{display:"table"}}>
                                <div style={{display:"table-cell",verticalAlign:"middle"}}>
                                    <div>
                                        <Label>{FOOTER_TEXT}</Label>
                                    </div>
                                </div>
                            </div>
                        </Stack>
                        <Stack horizontal>
                            <Stack style={{whiteSpace:"nowrap", minWidth: "40%", paddingLeft:20}} >
                                
                                <span style={{color:"gray",fontSize:"large"}}>Informatie</span>
                                
                                {/* <NavLink to='/Algemene Voorwaarden' style={{textDecoration:"none",color:"darkgray",paddingTop:5}}>
                                    <span style={{cursor:"pointer"}} onClick={()=>{ }}>Algemene Voorwaarden</span>
                                </NavLink> */}
                                <NavLink to='/Privacybeleid' style={{textDecoration:"none",color:"darkgray",paddingTop:5}} onClick={() => {props.UpdateStateExtern("firstload",false); }}>
                                    <span style={{cursor:"pointer",fontSize:"smaller"}} onClick={()=>{ }}>Privacybeleid</span>
                                </NavLink>
                                <NavLink to='/Over Ons' style={{textDecoration:"none",color:"darkgray",paddingTop:5}} onClick={() => {props.UpdateStateExtern("firstload",false); }}>
                                    <span style={{cursor:"pointer",fontSize:"smaller"}} onClick={()=>{ }}>Over Ons</span>
                                </NavLink>
                            </Stack>
                        </Stack>
                        
                        <Label className={styles.footerText}>
                            <br/>
                            <br/>
                        </Label>
                    </div>
                </div>
            </div>
        
    );
}

export default Footer;